import { ViewIds } from '@ardoq/api-types';
import type { ExportHandlerArgs } from '@ardoq/export';
import type { I18nLocale } from '@ardoq/i18n';
import { getStyleSheets } from 'tabview/getSharedExportFunctions';
import { getExportLabels } from 'views/getExportLabels';

type MetamodelExportConfig = Pick<
  ExportHandlerArgs,
  'exportedViewMetadata' | 'getStyleSheets' | 'labels'
> & { fileName: string };

export const toMetamodelExportConfig = (
  metamodelName: string,
  i18nLocale: I18nLocale
): MetamodelExportConfig => ({
  fileName: metamodelName,
  exportedViewMetadata: {
    name: ViewIds.SIMPLE_BLOCK_DIAGRAM,
    isViewpointMode: false,
  },
  getStyleSheets,
  labels: getExportLabels(i18nLocale),
});
